import Dashboard from './Dashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <main className="App-header">
        <Dashboard />
      </main>
    </div>
  );
}

export default App;
